import dayjs from 'dayjs';
import { parseLocalDate } from './dashboardUtils';
import styles from './DateBadge.module.css';

export function DateBadge({
  dateStr,
  locale,
  size = 'sm',
  inverted = false,
}: {
  dateStr: string;
  locale: string;
  size?: 'sm' | 'lg';
  /** White-on-dark text, for a badge sitting on a solid dark background. */
  inverted?: boolean;
}) {
  const d = dayjs(parseLocalDate(dateStr));
  const month = d.locale(locale).format('MMM').toUpperCase();
  const day = d.date();
  const monthClass = size === 'lg' ? styles.badgeMonthLg : styles.badgeMonthSm;
  const dayClass = size === 'lg' ? styles.badgeDayLg : styles.badgeDaySm;

  return (
    <>
      <div
        className={`${styles.badgeMonth} ${monthClass} ${inverted ? styles.badgeMonthInverted : ''}`}
      >
        {month}
      </div>
      <div
        className={`${styles.badgeDay} ${dayClass} ${inverted ? styles.badgeDayInverted : ''}`}
      >
        {day}
      </div>
    </>
  );
}
